import classNames from 'classnames'
import React from 'react'

import { noop } from '@ds'

import styles from './Button.module.scss'

export type ButtonSize = 'S' | 'M' | 'L'
export type ButtonVariant = 'primary' | 'secondary' | 'total-black'

interface ButtonProps {
  size?: ButtonSize
  variant?: ButtonVariant
  disabled?: boolean
  onClick?: () => void
  children: React.ReactNode
  style?: React.CSSProperties
  className?: string
}

export const NotButton: React.FC<ButtonProps> = ({
  size = 'S',
  variant = 'primary',
  disabled = false,
  onClick,
  children,
  style,
  className,
}) => {
  const buttonClass = classNames(
    styles.button,
    styles[size],
    styles[variant],
    className,
    {
      [styles.disabled]: disabled,
    }
  )

  return (
    <button
      className={buttonClass}
      onClick={disabled ? noop : onClick}
      disabled={disabled}
      style={style}
    >
      {children}
    </button>
  )
}
